import { profileIconImages } from "@/lib/constants";
import styles from "@/styles/Profile.module.scss";
import Image from "next/legacy/image";
import { memo } from "react";
import IconLock from "../../../src/svgs/icon_lock.svg";

function ProfileIconImage({
  icon,
  displayName,
  ownerProfile,
  needPasscode,
  onClick,
}) {
  const path = profileIconImages[icon] || profileIconImages[1];
  return (
    <div className={styles.icon} onClick={onClick}>
      {ownerProfile && !needPasscode && (
        <span className={styles.ownerLabel}>オーナー</span>
      )}
      {!ownerProfile && needPasscode && (
        <span className={styles.keyLabel}>
          <span className={styles.lock}>
            <IconLock />
          </span>
        </span>
      )}
      {ownerProfile && needPasscode && (
        <span className={styles.ownerAndKeyLabel}>
          <span className={styles.owner}>オーナー</span>
          <span className={styles.lock}>
            <IconLock />
          </span>
        </span>
      )}
      <div className={styles.image}>
        {!!path && <Image src={path} alt={displayName} layout="fill" />}
      </div>
      <div className={styles.name}>{displayName}</div>
    </div>
  );
}

export default memo(ProfileIconImage);
